// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1sXwm","title":"AfterFrontImage_title__1Ljzb"};